import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import hooks from '@g4/automation-hooks';

import Text from '@g4/boneyard/lib/Text';
// TODO: just as a quick fix for old boneyard hosted components
import oldTheme from '../../Colors';

export const InteractiveItem = styled.a`
  display: block;
  padding: 1rem;
  cursor: pointer;
`;

export const DisabledItem = styled.div`
  padding: 1rem;
  color: ${props => oldTheme.colors.common.disabledText};
  background-color: ${props => oldTheme.colors.modern.optionList.disabled};
`;

export class Option extends PureComponent {
  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);
    this.toRef = this.toRef.bind(this);
  }

  static propTypes = {
    /** Associates a specific action onto an element for the benefit of automated clients consuming it */
    automationHook: PropTypes.string,
    /** Item that is represented in the `Option` element */
    item: PropTypes.any.isRequired,
    /** Determines if this element has been selected (for styling purposes) */
    isSelected: PropTypes.bool,
    /** Function to execute when this element is selected */
    onSelect: PropTypes.func,
    /** Determines if the component should receive focus */
    autoFocus: PropTypes.bool,
    /** injects the generated stylesheet */
    className: PropTypes.string,
    /** decides if Option is disabled or not */
    disabled: PropTypes.bool,
    /** all component children nodes */
    children: PropTypes.node,
  };

  static defaultProps = {
    isSelected: false,
    onSelect: Function.prototype,
    autoFocus: false,
    disabled: false,
  };

  componentDidUpdate() {
    // Alternative to native 'autofocus' html attr which is not supported on Safari
    if (this.props.autoFocus) {
      this.el.focus();
    }
  }

  handleSelect(evt) {
    evt.preventDefault();
    this.props.onSelect(this.props.item);
  }

  toRef(el) {
    this.el = el;
  }

  render() {
    if (this.props.disabled) {
      return (
        <li className={this.props.className}>
          <DisabledItem>{this.props.children}</DisabledItem>
        </li>
      );
    }

    return (
      <li className={this.props.className}>
        <InteractiveItem
          href=""
          ref={this.toRef}
          role="button"
          tabIndex="-1"
          onClick={this.handleSelect}
          {...hooks.hook(this.props.automationHook)}
        >
          <Text size={16}>{this.props.children}</Text>
        </InteractiveItem>
      </li>
    );
  }
}

export default styled(Option)`
  color: ${props => oldTheme.colors.modern.optionList.text};
  border: 1px solid ${props => oldTheme.colors.modern.optionList.border};
  border-bottom: 0;
  background-color: #fff;

  &:last-child {
    border-bottom: 1px solid
      ${props => oldTheme.colors.modern.optionList.border};
  }

  ${props =>
    props.isSelected &&
    css`
      background-color: ${oldTheme.colors.common.selection};
    `};
`;
